import $api from '../../utils/api.js';

const SelectControl = {
    namespaced: true,
    state: {
       themes:[],
       music:[],
       participant:[],
       agents:[],
       filteredTransportationParticipant:[],
    },
    getters: {
        getFilteredParticipant: (state) => state.filteredTransportationParticipant,
    },
    mutations: {
        ASSIGN_THEMES(state, payload){
            state.themes = payload
        },
        ASSIGN_MUSIC(state, payload){
            state.music = payload
        },
        ASSIGN_AGENTS(state, payload){
            state.agents = payload
        },
        ASSIGN_PARTICIPANT(state, payload){
            state.participant = payload
        },
        FILTERED_PARTICIPANT(state, filter) {
            state.filteredTransportationParticipant = state.participant.filter((participant) => {
                return !filter.users.map((sel) => { return sel.user_id }).includes(participant.id) 
            })
        },
    },
    actions: {
        filterTransportationParticipant({ commit }, filter) {
            commit('FILTERED_PARTICIPANT', filter)
        },
        getThemes({commit}){
            return new Promise((resolve) => {
                $api.get(`select/themes`).then((response) => {
                    commit('ASSIGN_THEMES', response.data)
                    resolve(response.data)
                })
            })
        },
        getMusic({commit}){
            return new Promise((resolve) => {
                $api.get(`select/music`).then((response) => {
                    commit('ASSIGN_MUSIC', response.data)
                    resolve(response.data)
                })
            })
        },
        getAgents({commit},payload){
            return new Promise((resolve) => {
                $api.get(`select/user-agent/${payload}`).then((response) => {
                    commit('ASSIGN_AGENTS', response.data)
                    resolve(response.data)
                })
            })
        },
        getParticipant({commit}, payload){
            return new Promise((resolve) => {
                $api.get(`select/participant?level=${payload.level}&tier=${payload.tier}`).then((response) => {
                    commit('ASSIGN_PARTICIPANT', response.data)
                    resolve(response.data)
                })
            })
        },
    }
}

export default SelectControl